import React from 'react'
import ParticleDark from './ParticleDark';
import ParticleLight from './ParticleLight';

export const Background = ({ themeMode }) => {
  return (
    <div>
      { themeMode ? <ParticleLight /> : <ParticleDark />}
    </div>
  )
}

export default Background;
